import React from 'react';
type Tone = 'brand' | 'teal' | 'success' | 'warn' | 'danger' | 'navy';
interface ProgressBarProps {
  value: number;
  max?: number;
  tone?: Tone;
  size?: 'sm' | 'md' | 'lg';
  label: string;
  className?: string;
}
const toneClasses: Record<Tone, string> = {
  brand: 'bg-brand-500',
  teal: 'bg-teal-500',
  success: 'bg-success-500',
  warn: 'bg-warn-500',
  danger: 'bg-danger-500',
  navy: 'bg-navy-700'
};
const sizeClasses = {
  sm: 'h-1.5',
  md: 'h-2',
  lg: 'h-3'
};
export function ProgressBar({
  value,
  max = 100,
  tone = 'brand',
  size = 'md',
  label,
  className = ''
}: ProgressBarProps) {
  const safeMax = max <= 0 ? 1 : max;
  const percent = Math.max(0, Math.min(100, value / safeMax * 100));
  return <div role="progressbar" aria-label={label} aria-valuenow={Math.round(percent)} aria-valuemin={0} aria-valuemax={100} className={`w-full overflow-hidden rounded-full bg-navy-100 ${sizeClasses[size]} ${className}`} data-id="element-214" data-mp="2mded63qghlpk">
      <div className={`${toneClasses[tone]} h-full rounded-full transition-[width] duration-500 ease-out`} style={{
      width: `${percent}%`
    }} data-id="element-215" data-mp="22zgvltwdahdl" />
    </div>;
}